import(/* webpackMode: "eager" */ "/app/apps/web/app/error.tsx");
